module.exports = __webpack_public_path__ + "img/account-outline.b872c81a.png";